module.exports = __webpack_public_path__ + "media/images/jumping/promo-salud-section-bg-d767d2b992efc662ecacc7da5470fd3f.jpg";